import React, { useEffect, useState, useCallback } from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Button, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormikRangePicker, FormikSelect } from '../../components';
import { modality, activity, statuses } from './FormOptions';
import { getCoursesAndCompaniesByPeriodRequest } from '../../requests/courses';

const CourseFilter = props => {
  const { errors, touched, setFieldValue, setFieldTouched, values } = props;
  const dispatch = useDispatch();

  const [courseOptions, setCourseOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadFilteredOptions = useCallback(
    (dateFrom, dateTo) => {
      if (!dateFrom || !dateTo) {
        setCourseOptions([]);
        setCompanyOptions([]);
        return;
      }

      setLoading(true);

      getCoursesAndCompaniesByPeriodRequest({
        dispatch,
        params: {
          date_from: dateFrom,
          date_to: dateTo
        },
        successCallback: response => {
          const courses = response.data.courses.map(course => ({
            value: course.id,
            label: course.name
          }));

          const companies = response.data.companies.map(company => ({
            value: company.id,
            label: company.name
          }));

          setCourseOptions(courses);
          setCompanyOptions(companies);
          setLoading(false);
        },
        callback: () => {
          setLoading(false);
        }
      });
    },
    [dispatch]
  );

  useEffect(() => {
    loadFilteredOptions(values.date_from, values.date_to);
  }, [loadFilteredOptions, values.date_from, values.date_to]);

  return (
    <Form className="employee-search-form py-4 pl-4 mb-2">
      <Row>
        <Col xs={12} md={6} className="px-5">
          <Field name="rangeDate">
            {({ field }) => (
              <FormikRangePicker
                abbr
                name={field.name}
                minCurrentDate={false}
                startDateName="date_from"
                endDateName="date_to"
                startDate={values.date_from}
                endDate={values.date_to}
                onChange={(start, end) => {
                  setFieldValue('date_from', start);
                  setFieldValue('date_to', end);
                }}
                showClearDates
                label="Periodo Inicio Capacitación"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                appendToBody
                repositionPickerOnUpdate
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={3} className="px-5">
          <Field name="filter_course_name">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Nombre"
                placeholder="Seleccione un curso"
                options={courseOptions}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                isDisabled={!values.date_from || !values.date_to || loading}
                isLoading={loading}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                noOptionsMessage={() =>
                  !values.date_from || !values.date_to
                    ? 'Primero seleccione un período'
                    : 'No hay cursos en este período'
                }
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={3} className="px-5">
          <Field name="filter_company">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Empresa"
                placeholder="Seleccione una empresa"
                options={companyOptions}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                isDisabled={!values.date_from || !values.date_to || loading}
                isLoading={loading}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                noOptionsMessage={() =>
                  !values.date_from || !values.date_to
                    ? 'Primero seleccione un período'
                    : 'No hay empresas en este período'
                }
              />
            )}
          </Field>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col xs={12} md={3} className="px-5">
          <Field name="filter_activity_type">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Tipo de Actividad"
                placeholder="Seleccione"
                options={activity}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={3} className="px-5">
          <Field name="filter_course_modality">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Modalidad"
                placeholder="Seleccione"
                options={modality}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={3} className="px-5">
          <Field name="filter_status">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Estado"
                placeholder="Seleccione"
                options={statuses}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={12} md={{ span: 3, offset: 9 }} className="d-flex align-items-end px-5">
          <Button className="btn-block" type="submit">
            FILTRAR
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const handleSubmit = (values, { props }) => {
  props.formRequest(values);
};

const initialValues = {
  date_from: '',
  date_to: '',
  filter_course_name: '',
  filter_company: '',
  filter_activity_type: '',
  filter_course_modality: '',
  filter_status: ''
};

export default withFormik({
  initialValues,
  handleSubmit,
  enableReinitialize: true
})(CourseFilter);
